import { Coordinate } from "@omni/types/utils/coordinate.type";
import { useCallback, useEffect, useState } from "react";

import { calculateDelay } from "@/utils/menuContext";

const MOUSE_COORDINATES_TRACKED = 3;

export const useActivationDelay = () => {
    const [coordinates, setCoordinates] = useState<Array<Coordinate>>([]);

    const addCoordinate = useCallback((coordinate: Coordinate) => {
        setCoordinates((prev) => {
            return [...prev, coordinate].slice(-MOUSE_COORDINATES_TRACKED);
        });
    }, []);

    const getActivationDelay = useCallback(
        (menuElement: HTMLElement, activeIndex: number) => {
            return calculateDelay(menuElement, activeIndex, coordinates);
        },
        [coordinates]
    );

    useEffect(() => {
        const abortController = new AbortController();

        const eventHandler = (event: MouseEvent) => {
            addCoordinate({ x: event.pageX, y: event.pageY });
        };

        document.addEventListener("mousemove", eventHandler, {
            signal: abortController.signal
        });

        return () => abortController.abort();
    }, [addCoordinate]);

    return { getActivationDelay };
};
